import React from "react";
import SectionContainer from "../../components/SectionContainer";
import SectionHead from "../../components/SectionHead";
import ServicesBlock from "./ServicesBlock";
import ImageSlider from './ImageSlider';

const Services = () => {
  return (
    <SectionContainer id={"services"} secName={"services-sec"}>
      <SectionHead
        head={"services"}
        text={
          ""
        }
      />
      <ServicesBlock />
      <ImageSlider /> 
    </SectionContainer>
    
  );
};

export default Services;
